import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { TableComponentModule } from '@adaptiva/widgets/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CopyPropertiesOverlayComponent } from './copy-properties-overlay.component';

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		TableComponentModule,
	],
	declarations: [CopyPropertiesOverlayComponent],
	exports: [CopyPropertiesOverlayComponent]
})
export class CopyPropertiesOverlayModule {

}
